export default __webpack_public_path__ + "static/media/Mark-3-Blueprints-00.79c2f629.jpg";